import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_POSITION_ASSIGNMENTS_MUTATION = gql`
  mutation updateLineAssignments(
    $documentVersion: DocumentVersionInput,
    $lineId: String!,
    $variableAssignments: [VariableAssignmentInput!]!
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          configuration {
            setAssignments(variableAssignments: $variableAssignments) {
              line {
                id
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateLineAssignmentsMutation extends Mutation<RootMutation> {
  document = UPDATE_POSITION_ASSIGNMENTS_MUTATION;
}
